// Programme Primaire Francophone - Années 1-6
// Contenu du programme en français pour l'École Primaire Francophone d'Ambaebulu
// Basé sur le Programme National du Vanuatu

export const frenchPrimaryCurriculum = {
  // Langue et Communication
  languageCommunication: {
    subject: "Langue et Communication",
    description: "Développement des compétences de communication orale, écrite et visuelle en français et en langue vernaculaire.",
    strands: [
      {
        id: "ecoute-expression",
        title: "Écoute et Expression Orale",
        color: "blue",
        subStrands: ["Compétences et Stratégies", "Production", "Contexte et Textes"],
        yearlyOutcomes: {
          "Année 1": [
            "Utiliser les compétences de base d'écoute et d'expression orale",
            "Écouter et parler efficacement en utilisant la langue vernaculaire",
            "Reconnaître l'utilisation différente de la langue selon les situations"
          ],
          "Année 2": [
            "Démontrer des compétences d'écoute et d'expression orale en classe",
            "Parler avec confiance et écouter activement",
            "Reconnaître que la langue change selon les situations"
          ],
          "Année 3": [
            "Utiliser les compétences d'écoute et d'expression de manière cohérente",
            "Écouter et parler aux autres dans des situations formelles et informelles",
            "Adapter le discours à diverses situations familières"
          ],
          "Année 4": [
            "Développer le vocabulaire et la prononciation appropriés en français",
            "Écouter, parler et utiliser le vocabulaire approprié en français",
            "Démontrer un comportement approprié d'écoute et d'expression"
          ],
          "Année 5": [
            "Écouter et parler dans des situations familières",
            "Écouter, parler et interagir dans diverses situations",
            "Apprendre comment la langue orale change selon les objectifs et situations"
          ],
          "Année 6": [
            "Écouter et parler dans des situations familières et non familières",
            "Communiquer efficacement pour divers objectifs et audiences",
            "Apprendre comment la langue orale s'adapte aux différents contextes"
          ]
        }
      },
      {
        id: "lecture",
        title: "Lecture",
        color: "green",
        subStrands: ["Compétences et Stratégies", "Production", "Contexte et Textes"],
        yearlyOutcomes: {
          "Année 1": [
            "Utiliser les compétences de pré-lecture",
            "Démontrer le comportement de pré-lecture avec les textes",
            "Reconnaître que les images et les mots transmettent un sens"
          ],
          "Année 2": [
            "Développer les compétences pour lire des textes familiers",
            "Lire et répondre à des textes simples",
            "Reconnaître que les textes peuvent être imaginaires ou factuels"
          ],
          "Année 3": [
            "Utiliser les compétences pour lire des textes familiers",
            "Lire et comprendre des textes simples",
            "Décrire les objectifs des textes imaginaires et factuels"
          ],
          "Année 4": [
            "Sélectionner et appliquer des stratégies pour lire des textes simples en français",
            "Lire et comprendre des textes gradués simples en français",
            "Reconnaître que les textes sont écrits pour différents objectifs"
          ],
          "Année 5": [
            "Démontrer des compétences pour lire des textes familiers en français",
            "Lire et comprendre une variété de textes en français",
            "Identifier les types de textes utilisés pour différents objectifs"
          ],
          "Année 6": [
            "Appliquer une large gamme de compétences pour lire des textes en français",
            "Lire avec compréhension des textes de fiction et non-fiction",
            "Discuter comment différents types de textes sont utilisés"
          ]
        }
      },
      {
        id: "ecriture",
        title: "Écriture",
        color: "purple",
        subStrands: ["Compétences et Stratégies", "Production", "Contexte et Textes"],
        yearlyOutcomes: {
          "Année 1": [
            "Utiliser les compétences de pré-écriture",
            "Écrire des lettres et des mots simples",
            "Reconnaître que l'écriture transmet un sens"
          ],
          "Année 2": [
            "Développer les compétences d'écriture de base",
            "Écrire des phrases simples",
            "Comprendre les différents objectifs de l'écriture"
          ],
          "Année 3": [
            "Utiliser les compétences d'écriture dans des contextes familiers",
            "Écrire des paragraphes simples",
            "Utiliser la ponctuation de base"
          ],
          "Année 4": [
            "Développer les compétences d'écriture en français",
            "Écrire des textes courts en français",
            "Reconnaître les différents types de textes"
          ],
          "Année 5": [
            "Appliquer les compétences d'écriture pour différents objectifs",
            "Écrire des textes variés en français",
            "Utiliser les conventions d'écriture appropriées"
          ],
          "Année 6": [
            "Maîtriser les compétences d'écriture pour divers objectifs",
            "Écrire des textes complexes en français",
            "Adapter l'écriture aux différents contextes et audiences"
          ]
        }
      }
    ]
  },

  // Mathématiques
  mathematics: {
    subject: "Mathématiques",
    description: "Développement des compétences numériques, de mesure, de géométrie et de statistiques.",
    strands: [
      {
        id: "nombres",
        title: "Nombres",
        color: "blue",
        subStrands: ["Numération", "Opérations", "Résolution de Problèmes"],
        yearlyOutcomes: {
          "Année 1": [
            "Compter jusqu'à 20",
            "Reconnaître et écrire les nombres 0-20",
            "Comprendre les concepts de plus et moins"
          ],
          "Année 2": [
            "Compter jusqu'à 100",
            "Additionner et soustraire jusqu'à 20",
            "Résoudre des problèmes simples"
          ],
          "Année 3": [
            "Comprendre la valeur de position jusqu'à 1000",
            "Additionner et soustraire jusqu'à 100",
            "Introduction à la multiplication"
          ],
          "Année 4": [
            "Travailler avec des nombres jusqu'à 10 000",
            "Maîtriser les tables de multiplication",
            "Introduction aux fractions"
          ],
          "Année 5": [
            "Travailler avec des nombres jusqu'à 100 000",
            "Opérations avec les fractions",
            "Introduction aux décimales"
          ],
          "Année 6": [
            "Travailler avec des grands nombres",
            "Maîtriser les opérations avec fractions et décimales",
            "Résoudre des problèmes complexes"
          ]
        }
      },
      {
        id: "mesures",
        title: "Mesures",
        color: "green",
        subStrands: ["Longueur", "Masse", "Capacité", "Temps"],
        yearlyOutcomes: {
          "Année 1": [
            "Comparer des longueurs (plus long, plus court)",
            "Reconnaître les jours de la semaine",
            "Comparer des masses (plus lourd, plus léger)"
          ],
          "Année 2": [
            "Mesurer des longueurs avec des unités non standard",
            "Lire l'heure (heures entières)",
            "Comparer des capacités"
          ],
          "Année 3": [
            "Introduire les unités standard (cm, m)",
            "Lire l'heure (demi-heures, quarts)",
            "Introduire kg et L"
          ],
          "Année 4": [
            "Mesurer en cm, m, km",
            "Calculer la durée",
            "Travailler avec g, kg, mL, L"
          ],
          "Année 5": [
            "Convertir entre les unités de longueur",
            "Calculer le périmètre et l'aire",
            "Convertir entre les unités de masse et capacité"
          ],
          "Année 6": [
            "Maîtriser les conversions d'unités",
            "Calculer l'aire et le volume",
            "Résoudre des problèmes de mesure complexes"
          ]
        }
      },
      {
        id: "geometrie",
        title: "Géométrie",
        color: "orange",
        subStrands: ["Formes 2D", "Formes 3D", "Position et Mouvement"],
        yearlyOutcomes: {
          "Année 1": [
            "Reconnaître les formes de base (cercle, carré, triangle)",
            "Comprendre les positions (dessus, dessous, à côté)",
            "Identifier les formes dans l'environnement"
          ],
          "Année 2": [
            "Nommer et décrire les formes 2D",
            "Reconnaître les formes 3D de base",
            "Comprendre la symétrie simple"
          ],
          "Année 3": [
            "Classer les formes 2D par propriétés",
            "Nommer les formes 3D (cube, sphère, cylindre)",
            "Introduire les angles"
          ],
          "Année 4": [
            "Mesurer et dessiner des angles",
            "Identifier les lignes parallèles et perpendiculaires",
            "Explorer la symétrie"
          ],
          "Année 5": [
            "Calculer les angles manquants",
            "Classer les triangles et quadrilatères",
            "Introduire les transformations"
          ],
          "Année 6": [
            "Travailler avec les angles dans les polygones",
            "Maîtriser les transformations géométriques",
            "Résoudre des problèmes géométriques complexes"
          ]
        }
      },
      {
        id: "statistiques",
        title: "Statistiques",
        color: "purple",
        subStrands: ["Collecte de Données", "Représentation", "Interprétation"],
        yearlyOutcomes: {
          "Année 1": [
            "Trier et classer des objets",
            "Créer des pictogrammes simples",
            "Répondre à des questions sur les données"
          ],
          "Année 2": [
            "Collecter des données simples",
            "Créer des diagrammes à barres simples",
            "Interpréter des graphiques simples"
          ],
          "Année 3": [
            "Organiser les données dans des tableaux",
            "Créer et lire des diagrammes à barres",
            "Poser des questions sur les données"
          ],
          "Année 4": [
            "Collecter et organiser des données",
            "Créer différents types de graphiques",
            "Calculer la moyenne"
          ],
          "Année 5": [
            "Planifier la collecte de données",
            "Interpréter divers graphiques",
            "Calculer moyenne, médiane, mode"
          ],
          "Année 6": [
            "Mener des enquêtes statistiques",
            "Présenter les données de différentes manières",
            "Analyser et interpréter les résultats"
          ]
        }
      }
    ]
  },

  // Sciences
  science: {
    subject: "Sciences",
    description: "Exploration du monde naturel et physique à travers l'investigation scientifique.",
    strands: [
      {
        id: "etres-vivants",
        title: "Êtres Vivants",
        color: "green",
        subStrands: ["Plantes", "Animaux", "Corps Humain", "Écosystèmes"],
        yearlyOutcomes: {
          "Année 1": [
            "Identifier les êtres vivants et non vivants",
            "Observer les parties des plantes",
            "Reconnaître les animaux familiers"
          ],
          "Année 2": [
            "Comprendre les besoins des êtres vivants",
            "Observer la croissance des plantes",
            "Classer les animaux simples"
          ],
          "Année 3": [
            "Comprendre les cycles de vie",
            "Identifier les parties du corps humain",
            "Explorer les habitats locaux"
          ],
          "Année 4": [
            "Étudier les chaînes alimentaires",
            "Comprendre les systèmes du corps",
            "Explorer les adaptations des animaux"
          ],
          "Année 5": [
            "Comprendre les écosystèmes",
            "Étudier la reproduction des plantes",
            "Explorer l'interdépendance des organismes"
          ],
          "Année 6": [
            "Analyser les réseaux alimentaires",
            "Comprendre l'évolution et l'adaptation",
            "Étudier la conservation de l'environnement"
          ]
        }
      },
      {
        id: "materiaux",
        title: "Matériaux",
        color: "orange",
        subStrands: ["Propriétés", "Changements", "Utilisation"],
        yearlyOutcomes: {
          "Année 1": [
            "Explorer les propriétés des matériaux (dur, mou)",
            "Trier les matériaux par propriétés",
            "Identifier les matériaux dans l'environnement"
          ],
          "Année 2": [
            "Comparer les propriétés des matériaux",
            "Observer les changements simples des matériaux",
            "Comprendre les utilisations des matériaux"
          ],
          "Année 3": [
            "Classer les matériaux (solide, liquide, gaz)",
            "Observer la fusion et la solidification",
            "Comprendre les matériaux naturels et fabriqués"
          ],
          "Année 4": [
            "Étudier les changements réversibles et irréversibles",
            "Explorer les propriétés des métaux et non-métaux",
            "Comprendre le recyclage"
          ],
          "Année 5": [
            "Comprendre les mélanges et solutions",
            "Étudier les méthodes de séparation",
            "Explorer les changements chimiques"
          ],
          "Année 6": [
            "Analyser les propriétés des matériaux",
            "Comprendre les réactions chimiques",
            "Évaluer l'impact environnemental des matériaux"
          ]
        }
      },
      {
        id: "energie",
        title: "Énergie",
        color: "yellow",
        subStrands: ["Lumière", "Son", "Électricité", "Forces"],
        yearlyOutcomes: {
          "Année 1": [
            "Explorer les sources de lumière",
            "Reconnaître différents sons",
            "Observer les forces de poussée et traction"
          ],
          "Année 2": [
            "Comprendre la lumière et l'ombre",
            "Explorer comment les sons sont produits",
            "Expérimenter avec les aimants"
          ],
          "Année 3": [
            "Étudier la réflexion de la lumière",
            "Comprendre la hauteur et le volume du son",
            "Introduction aux circuits simples"
          ],
          "Année 4": [
            "Explorer la réfraction de la lumière",
            "Étudier la propagation du son",
            "Construire des circuits électriques"
          ],
          "Année 5": [
            "Comprendre les sources d'énergie",
            "Étudier les conducteurs et isolants",
            "Explorer les forces et le mouvement"
          ],
          "Année 6": [
            "Analyser les transferts d'énergie",
            "Comprendre l'énergie renouvelable",
            "Étudier les forces équilibrées et non équilibrées"
          ]
        }
      },
      {
        id: "terre-espace",
        title: "Terre et Espace",
        color: "blue",
        subStrands: ["Terre", "Météo", "Espace"],
        yearlyOutcomes: {
          "Année 1": [
            "Observer le temps qu'il fait",
            "Reconnaître le jour et la nuit",
            "Explorer les roches et le sol"
          ],
          "Année 2": [
            "Comprendre les saisons",
            "Observer le cycle de l'eau",
            "Explorer les caractéristiques de la Terre"
          ],
          "Année 3": [
            "Étudier les types de roches",
            "Comprendre le cycle de l'eau",
            "Introduction au système solaire"
          ],
          "Année 4": [
            "Explorer les volcans et tremblements de terre",
            "Étudier les phénomènes météorologiques",
            "Comprendre la rotation de la Terre"
          ],
          "Année 5": [
            "Étudier les couches de la Terre",
            "Analyser les changements climatiques",
            "Explorer les planètes du système solaire"
          ],
          "Année 6": [
            "Comprendre les plaques tectoniques",
            "Étudier l'impact humain sur l'environnement",
            "Explorer l'univers au-delà du système solaire"
          ]
        }
      }
    ]
  },

  // Sciences Sociales
  socialScience: {
    subject: "Sciences Sociales",
    description: "Compréhension de la société, de l'histoire, de la géographie et de la culture du Vanuatu.",
    strands: [
      {
        id: "identite-culture",
        title: "Identité et Culture",
        color: "purple",
        subStrands: ["Moi et Ma Famille", "Ma Communauté", "Mon Pays"],
        yearlyOutcomes: {
          "Année 1": [
            "Parler de soi et de sa famille",
            "Reconnaître les membres de la famille",
            "Comprendre son rôle dans la famille"
          ],
          "Année 2": [
            "Explorer la famille élargie",
            "Comprendre les traditions familiales",
            "Respecter les différentes familles"
          ],
          "Année 3": [
            "Identifier sa communauté",
            "Comprendre les rôles dans la communauté",
            "Explorer les traditions locales"
          ],
          "Année 4": [
            "Étudier l'histoire de sa communauté",
            "Comprendre les lois et règles",
            "Explorer la culture du Vanuatu"
          ],
          "Année 5": [
            "Comprendre la diversité culturelle du Vanuatu",
            "Étudier les langues et coutumes",
            "Analyser les changements sociaux"
          ],
          "Année 6": [
            "Explorer l'identité nationale",
            "Comprendre les droits et responsabilités",
            "Analyser la place du Vanuatu dans le Pacifique"
          ]
        }
      },
      {
        id: "lieu-environnement",
        title: "Lieu et Environnement",
        color: "green",
        subStrands: ["Géographie Locale", "Environnement", "Ressources"],
        yearlyOutcomes: {
          "Année 1": [
            "Reconnaître les lieux familiers",
            "Comprendre les directions simples",
            "Observer l'environnement local"
          ],
          "Année 2": [
            "Créer des cartes simples",
            "Identifier les caractéristiques géographiques",
            "Comprendre les ressources naturelles"
          ],
          "Année 3": [
            "Lire des cartes simples",
            "Étudier les îles du Vanuatu",
            "Explorer les écosystèmes locaux"
          ],
          "Année 4": [
            "Comprendre les cartes et légendes",
            "Étudier le climat du Vanuatu",
            "Analyser l'utilisation des terres"
          ],
          "Année 5": [
            "Explorer la géographie du Pacifique",
            "Comprendre les changements environnementaux",
            "Étudier la gestion des ressources"
          ],
          "Année 6": [
            "Analyser les questions environnementales",
            "Comprendre le développement durable",
            "Explorer les connexions mondiales"
          ]
        }
      },
      {
        id: "temps-changement",
        title: "Temps et Changement",
        color: "orange",
        subStrands: ["Passé", "Présent", "Futur"],
        yearlyOutcomes: {
          "Année 1": [
            "Comprendre hier, aujourd'hui, demain",
            "Parler du passé personnel",
            "Séquencer les événements"
          ],
          "Année 2": [
            "Explorer l'histoire familiale",
            "Comprendre les changements dans le temps",
            "Utiliser les lignes du temps simples"
          ],
          "Année 3": [
            "Étudier l'histoire de la communauté",
            "Comprendre les sources historiques",
            "Comparer passé et présent"
          ],
          "Année 4": [
            "Explorer l'histoire du Vanuatu",
            "Étudier les premiers habitants",
            "Comprendre l'arrivée des Européens"
          ],
          "Année 5": [
            "Analyser la période coloniale",
            "Étudier l'indépendance du Vanuatu",
            "Comprendre les changements récents"
          ],
          "Année 6": [
            "Explorer l'histoire du Pacifique",
            "Analyser les événements historiques",
            "Réfléchir sur l'avenir du Vanuatu"
          ]
        }
      },
      {
        id: "organisation-sociale",
        title: "Organisation Sociale",
        color: "blue",
        subStrands: ["Gouvernement", "Économie", "Citoyenneté"],
        yearlyOutcomes: {
          "Année 1": [
            "Comprendre les règles de la classe",
            "Respecter les autres",
            "Partager et coopérer"
          ],
          "Année 2": [
            "Comprendre les règles de l'école",
            "Identifier les leaders",
            "Travailler en groupe"
          ],
          "Année 3": [
            "Explorer l'organisation communautaire",
            "Comprendre les chefs traditionnels",
            "Participer à la vie communautaire"
          ],
          "Année 4": [
            "Étudier le gouvernement local",
            "Comprendre les services publics",
            "Introduire l'économie simple"
          ],
          "Année 5": [
            "Comprendre le gouvernement national",
            "Étudier les droits des enfants",
            "Analyser l'économie du Vanuatu"
          ],
          "Année 6": [
            "Explorer la démocratie",
            "Comprendre la citoyenneté active",
            "Analyser les organisations internationales"
          ]
        }
      }
    ]
  }
};

// French Weekly Lesson Schemes
export const frenchPrimaryWeeklyLessons = {
  year1: {
    term1: {
      weeks: [
        { week: 1, strand: "Nombres", topic: "Compter jusqu'à 10", learningOutcomes: ["Compter de 1 à 10", "Reconnaître les nombres", "Écrire les nombres"], activities: ["Comptage en groupe", "Jeux de nombres", "Traçage des chiffres"], resources: ["Cartes de nombres", "Cubes à compter"], assessment: "Observation" },
        { week: 2, strand: "Nombres", topic: "Comparer les quantités", learningOutcomes: ["Comparer plus et moins", "Utiliser le vocabulaire comparatif", "Résoudre des problèmes simples"], activities: ["Tri d'objets", "Jeux de comparaison", "Travail en groupe"], resources: ["Objets à compter", "Images"], assessment: "Travail pratique" },
        { week: 3, strand: "Lecture", topic: "Les lettres de l'alphabet", learningOutcomes: ["Reconnaître les lettres A-M", "Associer lettres et sons", "Tracer les lettres"], activities: ["Chansons de l'alphabet", "Traçage dans le sable", "Jeux de lettres"], resources: ["Cartes de lettres", "Sable", "Cahiers"], assessment: "Observation" },
        { week: 4, strand: "Lecture", topic: "Suite de l'alphabet", learningOutcomes: ["Reconnaître les lettres N-Z", "Associer lettres et sons", "Former des mots simples"], activities: ["Jeux de mémoire", "Activités de tri", "Lecture d'images"], resources: ["Flashcards", "Livres d'images"], assessment: "Quiz oral" },
        { week: 5, strand: "Écriture", topic: "Traçage et motricité fine", learningOutcomes: ["Tenir le crayon correctement", "Tracer des lignes et formes", "Développer la coordination"], activities: ["Exercices de traçage", "Dessin libre", "Découpage"], resources: ["Cahiers de traçage", "Ciseaux", "Papier"], assessment: "Portfolio" },
        { week: 6, strand: "Sciences", topic: "Mon corps", learningOutcomes: ["Nommer les parties du corps", "Comprendre leurs fonctions", "Prendre soin de son corps"], activities: ["Chanson du corps", "Dessiner le corps", "Hygiène pratique"], resources: ["Affiches du corps", "Miroirs"], assessment: "Dessin légendé" },
        { week: 7, strand: "Sciences Sociales", topic: "Ma famille", learningOutcomes: ["Identifier les membres de la famille", "Comprendre les relations familiales", "Parler de sa famille"], activities: ["Arbre généalogique", "Présentation orale", "Jeux de rôle"], resources: ["Photos de famille", "Papier", "Crayons"], assessment: "Présentation" },
        { week: 8, strand: "Géométrie", topic: "Les formes", learningOutcomes: ["Reconnaître cercle, carré, triangle", "Trouver des formes autour de soi", "Dessiner des formes"], activities: ["Chasse aux formes", "Collage de formes", "Jeux de tri"], resources: ["Blocs de formes", "Papier coloré"], assessment: "Travail pratique" },
        { week: 9, strand: "Révision", topic: "Révision du trimestre", learningOutcomes: ["Réviser les concepts appris", "Consolider les compétences", "Préparer l'évaluation"], activities: ["Jeux de révision", "Activités mixtes", "Questions-réponses"], resources: ["Matériel varié"], assessment: "Évaluation de trimestre" },
        { week: 10, strand: "Évaluation", topic: "Évaluation de fin de trimestre", learningOutcomes: ["Démontrer les apprentissages", "Appliquer les compétences", "Évaluer les progrès"], activities: ["Tests écrits", "Activités pratiques", "Entretiens"], resources: ["Feuilles d'évaluation"], assessment: "Examen de trimestre" }
      ]
    },
    term2: {
      weeks: [
        { week: 1, strand: "Nombres", topic: "Compter jusqu'à 20", learningOutcomes: ["Compter de 11 à 20", "Écrire les nombres", "Comparer les nombres"], activities: ["Comptage avec objets", "Jeux de nombres", "Exercices écrits"], resources: ["Cartes de nombres", "Objets à compter"], assessment: "Quiz" },
        { week: 2, strand: "Nombres", topic: "Addition simple", learningOutcomes: ["Comprendre l'addition", "Additionner jusqu'à 10", "Résoudre des problèmes"], activities: ["Manipulation d'objets", "Histoires mathématiques", "Travail en binôme"], resources: ["Cubes", "Fiches de travail"], assessment: "Exercices" },
        { week: 3, strand: "Lecture", topic: "Les syllabes", learningOutcomes: ["Identifier les syllabes", "Frapper les syllabes", "Former des mots"], activities: ["Jeux de syllabes", "Chansons", "Lecture guidée"], resources: ["Cartes de syllabes", "Livres de lecture"], assessment: "Lecture orale" },
        { week: 4, strand: "Lecture", topic: "Mots fréquents", learningOutcomes: ["Reconnaître les mots courants", "Lire des phrases simples", "Comprendre le sens"], activities: ["Flash cards", "Lecture répétée", "Jeux de mots"], resources: ["Cartes de mots", "Affiches"], assessment: "Test de lecture" },
        { week: 5, strand: "Écriture", topic: "Écrire des mots", learningOutcomes: ["Copier des mots", "Écrire des mots simples", "Utiliser l'espacement"], activities: ["Copie guidée", "Dictée de mots", "Écriture libre"], resources: ["Modèles d'écriture", "Cahiers"], assessment: "Dictée" },
        { week: 6, strand: "Sciences", topic: "Les plantes", learningOutcomes: ["Identifier les parties des plantes", "Comprendre les besoins des plantes", "Observer la croissance"], activities: ["Plantation de graines", "Observation et dessin", "Journal de croissance"], resources: ["Graines", "Pots", "Terre"], assessment: "Projet" },
        { week: 7, strand: "Sciences Sociales", topic: "Mon école", learningOutcomes: ["Connaître les lieux de l'école", "Identifier le personnel", "Respecter les règles"], activities: ["Visite de l'école", "Interviews", "Création d'affiches"], resources: ["Plan de l'école", "Appareils photo"], assessment: "Présentation" },
        { week: 8, strand: "Mesures", topic: "Comparer les longueurs", learningOutcomes: ["Comparer plus long/plus court", "Utiliser des unités non standard", "Estimer les longueurs"], activities: ["Mesure avec les mains", "Tri par longueur", "Jeux de comparaison"], resources: ["Objets variés", "Ficelle"], assessment: "Travail pratique" },
        { week: 9, strand: "Révision", topic: "Révision du trimestre", learningOutcomes: ["Réviser les apprentissages", "Pratiquer les compétences", "Se préparer à l'évaluation"], activities: ["Activités de révision", "Jeux éducatifs", "Travail individuel"], resources: ["Matériel de révision"], assessment: "Préparation à l'examen" },
        { week: 10, strand: "Évaluation", topic: "Évaluation de fin de trimestre", learningOutcomes: ["Démontrer la compréhension", "Appliquer les compétences acquises", "Évaluer les progrès"], activities: ["Tests", "Activités pratiques", "Auto-évaluation"], resources: ["Documents d'évaluation"], assessment: "Examen" }
      ]
    },
    term3: {
      weeks: [
        { week: 1, strand: "Nombres", topic: "Soustraction simple", learningOutcomes: ["Comprendre la soustraction", "Soustraire jusqu'à 10", "Résoudre des problèmes"], activities: ["Manipulation", "Histoires", "Exercices"], resources: ["Cubes", "Fiches"], assessment: "Exercices" },
        { week: 2, strand: "Nombres", topic: "Révision des opérations", learningOutcomes: ["Pratiquer addition et soustraction", "Choisir l'opération", "Vérifier les réponses"], activities: ["Jeux mathématiques", "Travail en groupe", "Compétitions"], resources: ["Cartes de calcul", "Dés"], assessment: "Quiz" },
        { week: 3, strand: "Lecture", topic: "Lecture de phrases", learningOutcomes: ["Lire des phrases complètes", "Comprendre le sens", "Répondre aux questions"], activities: ["Lecture guidée", "Questions-réponses", "Théâtre de lecteurs"], resources: ["Livres gradués", "Fiches de compréhension"], assessment: "Test de lecture" },
        { week: 4, strand: "Écriture", topic: "Écrire des phrases", learningOutcomes: ["Former des phrases simples", "Utiliser la majuscule et le point", "Exprimer ses idées"], activities: ["Écriture guidée", "Journal", "Histoires illustrées"], resources: ["Cahiers", "Modèles"], assessment: "Production écrite" },
        { week: 5, strand: "Sciences", topic: "Les animaux", learningOutcomes: ["Classer les animaux", "Comprendre leurs besoins", "Respecter les animaux"], activities: ["Tri d'images", "Vidéos", "Création d'affiches"], resources: ["Images d'animaux", "Vidéos"], assessment: "Projet" },
        { week: 6, strand: "Sciences Sociales", topic: "Ma communauté", learningOutcomes: ["Identifier les lieux importants", "Connaître les métiers", "Comprendre les services"], activities: ["Carte de la communauté", "Jeux de rôle", "Visite"], resources: ["Photos locales", "Carte"], assessment: "Présentation" },
        { week: 7, strand: "Statistiques", topic: "Trier et compter", learningOutcomes: ["Trier par catégories", "Compter les groupes", "Créer des graphiques simples"], activities: ["Tri de boutons", "Graphiques en blocs", "Enquête de classe"], resources: ["Objets à trier", "Papier quadrillé"], assessment: "Projet" },
        { week: 8, strand: "Géométrie", topic: "Position et direction", learningOutcomes: ["Utiliser dessus/dessous/à côté", "Suivre des directions", "Donner des directions"], activities: ["Jeux de position", "Parcours", "Instructions orales"], resources: ["Jouets", "Espace de jeu"], assessment: "Observation" },
        { week: 9, strand: "Révision", topic: "Révision de l'année", learningOutcomes: ["Réviser tous les apprentissages", "Identifier les forces et faiblesses", "Consolider les compétences"], activities: ["Révision complète", "Jeux éducatifs", "Portfolio"], resources: ["Tout le matériel"], assessment: "Préparation finale" },
        { week: 10, strand: "Évaluation", topic: "Évaluation de fin d'année", learningOutcomes: ["Démontrer la maîtrise", "Appliquer toutes les compétences", "Célébrer les réussites"], activities: ["Examens finaux", "Présentations", "Fête de fin d'année"], resources: ["Documents d'évaluation"], assessment: "Examen final" }
      ]
    }
  }
};

// Export default
export default frenchPrimaryCurriculum;
